import React from 'react';
import { Link } from 'react-router-dom';
import { PackageCheck, RotateCcw, Truck } from 'lucide-react';
const RATES = [{
  method: 'Standard (3–5 business days)',
  cost: '$5.95 — free over $99'
}, {
  method: 'Expedited (2 business days)',
  cost: '$14.95'
}, {
  method: 'Overnight (next business day)',
  cost: '$29.95'
}];
export function Shipping() {
  return <div className="w-full min-h-screen bg-white" data-id="element-2826" data-mp="1fdbpqrjnyen0">
      <section className="pt-32 md:pt-36 pb-12 md:pb-16 px-6" data-id="element-2827" data-mp="1fcina2rqmbao">
        <div className="max-w-3xl mx-auto" data-id="element-2828" data-mp="1jdcg9ak1egaf">
          <div className="text-sm text-[#5A5A5A] mb-6" data-id="element-2829" data-mp="1jg8d0vk5eyxa">
            <Link to="/" className="hover:text-tealslate transition-colors underline decoration-[#E5E5E5] underline-offset-4" data-id="element-2830" data-mp="1oei5uziehnfq">
              Home
            </Link>{' '}
            <span className="mx-2" data-id="element-2831" data-mp="3q6eiydk7v5cm">/</span> Shipping &amp; Returns
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-[#1F1F1F] mb-4 tracking-tight" data-id="element-2832" data-mp="3v4zkqhf49x36">
            Shipping &amp; returns
          </h1>
          <p className="text-base text-[#5A5A5A]" data-id="element-2833" data-mp="1ii12i94207c4">
            Free US shipping over $99, tracked delivery on every order, and 30
            days to change your mind.
          </p>
        </div>
      </section>

      <section className="pb-4 px-6" data-id="element-2834" data-mp="18nsf1ztvr4kt">
        <div className="max-w-3xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-2835" data-mp="14pcjh7jqgnvs">
          {[{
          icon: Truck,
          title: 'Ships in 1–2 days',
          copy: 'From our US warehouse, with tracking emailed to you.'
        }, {
          icon: RotateCcw,
          title: '30-day returns',
          copy: 'Opened or unopened, refunded to your original payment method.'
        }, {
          icon: PackageCheck,
          title: 'Damaged in transit?',
          copy: 'Send a photo and we replace it — no return needed.'
        }].map(item => <div key={item.title} className="rounded-2xl border border-[#E5E5E5] bg-white p-6" data-id="element-2836" data-mp="dh1gmithulwh">
              <item.icon className="w-6 h-6 text-tealslate mb-4" strokeWidth={1.75} data-id="element-2837" data-mp="if31n9ahcval" />
              <h2 className="text-base font-bold text-[#1F1F1F] mb-2" data-id="element-2838" data-mp="4g3de2qvqiey">
                {item.title}
              </h2>
              <p className="text-sm text-[#5A5A5A] leading-relaxed" data-id="element-2839" data-mp="8jsyujc9cjvr">
                {item.copy}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-14 md:py-20 px-6" data-id="element-2840" data-mp="3vnz172bypxtl">
        <div className="max-w-3xl mx-auto space-y-14" data-id="element-2841" data-mp="3gy9xp0gedhq5">
          <div data-id="element-2842" data-mp="3gzkxkp6q25bz">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1F1F1F] tracking-tight mb-6" data-id="element-2843" data-mp="3gvx6dwor1v0f">
              Rates &amp; delivery times
            </h2>
            <dl className="border-t border-[#E5E5E5]" data-id="element-2844" data-mp="37yegof05usi7">
              {RATES.map(rate => <div key={rate.method} className="flex items-baseline justify-between gap-6 border-b border-[#E5E5E5] py-4" data-id="element-2845" data-mp="3cv4wd181zm33">
                  <dt className="text-base text-[#1F1F1F]" data-id="element-2846" data-mp="2obtc0alh6huo">{rate.method}</dt>
                  <dd className="text-base font-bold text-[#1F1F1F] text-right shrink-0" data-id="element-2847" data-mp="32b2w3lcsxw3x">
                    {rate.cost}
                  </dd>
                </div>)}
            </dl>
            <p className="text-sm text-[#5A5A5A] leading-relaxed mt-5" data-id="element-2848" data-mp="3c98vnwb4yq5m">
              Delivery estimates start the day your order leaves the warehouse.
              We currently ship within the United States only, including Alaska
              and Hawaii. Digital books are delivered by email immediately after
              checkout and never incur a shipping charge.
            </p>
          </div>

          <div data-id="element-2849" data-mp="3uzqaqy31pn8i">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1F1F1F] tracking-tight mb-6" data-id="element-2850" data-mp="3uz73cbb0uh8q">
              How to start a return
            </h2>
            <ol className="space-y-5" data-id="element-2851" data-mp="3q2glpjjkjdl7">
              {['Email support with your order number and which items you want to return.', 'We send a prepaid label within one business day.', 'Drop the package off, then watch for your refund — it posts 3–5 business days after the return is scanned.'].map((step, index) => <li key={step} className="flex gap-4" data-id="element-2852" data-mp="221l2luq792xn" data-mpi={index}>
                  <span className="shrink-0 w-7 h-7 rounded-full bg-[#1F1F1F] text-white text-xs font-bold flex items-center justify-center" data-id="element-2853" data-mp="15cvhzwn6tw7z">
                    {index + 1}
                  </span>
                  <p className="text-base text-[#5A5A5A] leading-relaxed pt-1" data-id="element-2854" data-mp="1edjv8p4rbsjt">
                    {step}
                  </p>
                </li>)}
            </ol>
            <p className="text-sm text-[#5A5A5A] leading-relaxed mt-6" data-id="element-2855" data-mp="1ja0mhs796n14">
              Digital books are non-returnable because access is granted
              instantly — if a download fails, contact support and we'll fix it.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#F9F9F9] py-16 md:py-20 px-6 border-t border-[#E5E5E5]" data-id="element-2856" data-mp="34xl0w5sgbu2e">
        <div className="max-w-2xl mx-auto text-center" data-id="element-2857" data-mp="2zx5pvkvn6ynl">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1F1F1F] tracking-tight mb-3" data-id="element-2858" data-mp="2v4vu3o7uj4de">
            Need help with an order?
          </h2>
          <p className="text-base text-[#5A5A5A] mb-8" data-id="element-2859" data-mp="2r3tuv7dxisbf">
            Order questions, returns, and damaged packages all go to the same
            inbox.
          </p>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-2860" data-mp="2h4uqi1075iu8">
            <Link to="/contact" className="inline-flex px-7 py-3.5 bg-[#1F1F1F] text-white text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#3B3B3B] transition-colors rounded" data-id="element-2861" data-mp="2c6ji7upjvge4">
              Contact Support
            </Link>
            <Link to="/faq" className="inline-flex px-7 py-3.5 border border-[#E5E5E5] bg-white text-[#1F1F1F] text-xs font-bold uppercase tracking-[0.2em] hover:border-[#1F1F1F] transition-colors rounded" data-id="element-2862" data-mp="adc3amdun0sr">
              Read the FAQ
            </Link>
          </div>
        </div>
      </section>
    </div>;
}